import { fork, select, take, put } from 'redux-saga/effects';
import { getLayout, getSync } from 'selectors/monitoringSelectors';
import { CellIndex } from 'types';
import { TimelineClickAction } from 'actions/timelineActions';
import { seek } from 'actions/monitoringActions';


export function* timelineClickWatcher() {
    while (true) {
        // Wait for the user to click a timeline
        const action: TimelineClickAction = yield take('TIMELINE_CLICK');
        yield fork(syncTimelineClickSaga, action);
    }
}

function* syncTimelineClickSaga(action: TimelineClickAction) {
    const { cellIndex, utcTime } = action.payload;

    // Collect all the cells we need to update -- Start with the specified cell
    const cellsToUpdate = [
        cellIndex,
    ];

    // Does the specified cell have its zoom synchronization flag set?
    const sync: boolean = yield select(getSync, { cellIndex });

    // If so, find out which other cells have their flag set too
    if (sync) {
        const nCells: number = yield select(getLayout);
        for (let i = 1 as CellIndex; i <= nCells; i++) {
            if (i === cellIndex) continue; // We've already got this one
            
            if (yield select(getSync, { cellIndex: i })) {
                cellsToUpdate.push(i);
            }
        }
    }

    // Make all the cells that we just collected seek to the same time
    while (cellsToUpdate.length) {
        const cellIndex = cellsToUpdate.shift() as CellIndex;
        yield put(seek({ cellIndex, utcTime, seekType: 'to' }));
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/syncTimelineClickSaga.ts